import Story from '@/models/Story'

export default class Stage extends Story {
  public get type() {
    return 'stage'
  }
}
